<template>
    <div>
        <h1 class="display-heading">New Prescription</h1>
        <div class="card mb-3">
            <div class="card-header d-flex justify-content-between align-items-baseline">
                <span>Patient Details</span>
            </div>
            <div class="card-body">
                <table class="table table-bordered table-sm">
                    <colgroup>
                        <col width="250">
                        <col>
                    </colgroup>
                    <tr>
                        <th colspan="2" class="text-uppercase">General Info</th>
                    </tr>
                    <tr>
                        <th>Join Date</th>
                        <td>{{userProfile.joinedDate}}</td>
                    </tr>
                    <tr>
                        <th>Full Name</th>
                        <td>{{userProfile.designation ? `${userProfile.designation} ${userProfile.name}` : userProfile.name }}</td>
                    </tr>
                    <tr>
                        <th>Identification Type</th>
                        <td>{{userProfile.identitifcationType}}</td>
                    </tr>
                    <tr>
                        <th>Identification Number</th>
                        <td>{{userProfile.identificationNumber}}</td>
                    </tr>
                    <tr>
                        <th>Birth Date</th>
                        <td>{{userProfile.birthDate}}</td>
                    </tr>
                    <tr>
                        <th>Gender</th>
                        <td>{{userProfile.gender}}</td>
                    </tr>
                    <tr>
                        <th>Email Address</th>
                        <td>{{userProfile.email}}</td>
                    </tr>
                    <tr>
                        <th>Phone Number</th>
                        <td>{{userProfile.phoneNo}}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="card mb-3">
            <div class="card-header d-flex justify-content-between align-items-baseline">
                <span>Prescription List</span>
                <button class="btn btn-info btn-info-insv" type="button" @click="viewPatientPastPrescriptions">
                    View Patient Past Prescriptions
                </button>
            </div>
            <div class="card-body">
                <prescription-detail :isEdit="true" v-model="prescriptionList"
                    :pharmacyId="pharmacyId" :drugType="2">
                    <!-- <template v-if="prescriptionList.length> 0">
                            <form data-vv-scope="prescription-valid-days" @submit.prevent="validatePrescriptionValidDays">
                                <div id="prescription" class="d-flex align-items-baseline">
                                    <label class="mr-2 mb-0">{{ isEditPrescription ? "Prescription Valid for (Days):" : "Prescription valid until"}}  </label>
                                    <input name="prescriptionValidDays" type="text"
                                        v-if="isEditPrescription"
                                        data-vv-validate-on="blur" data-vv-as="prescription valid"
                                        v-validate="'required|numeric|min_value:1'"
                                        v-model="prescriptionValidDays" :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('prescription-valid-days.prescriptionValidDays')
                                    }">
                                    <div v-else>
                                        {{prescriptionValidUntil ? convertToUserReadableDate(prescriptionValidUntil): '-'}}
                                    </div>
                                </div>
                            </form>
                    </template> -->
                </prescription-detail>
            </div>
        </div>
        <div v-if="saveErrorMessage" class="text-danger mb-2">{{ saveErrorMessage }}</div>
        <div v-if="isGettingPrice" class="mb-2">Calculating total charge, please wait...</div>
        <button class="btn btn-primary btn-primary-insv" type="button" :disabled="isGettingPrice" @click="proceedToPayment">
            Proceed to Payment
        </button>

        <popup-modal ref="confirmPrescription" :hasCloseButton="false" :title="savingPrescription ? 'Saving Prescription' : 'Confirm Prescription?'">
            <template slot="content">
                <!-- <div>{{ savingPrescription ? 'Creating prescription, please wait...' :'Confirm prescription and proceed to payment?' }}</div> -->
                <div v-if="savingPrescription">Creating prescription, please wait...</div>
                <div v-else>
                    <div>Total Charge: <b>RM {{total}}</b></div>
                    <div class="mt-2">Confirm prescription, total charge and proceed to payment?</div>
                </div>
            </template>
            <template slot="footer">
                <button :disabled="savingPrescription" type="button" class="btn btn-primary btn-primary-insv" @click="confirmProceed">Confirm</button>
                <button :disabled="savingPrescription" type="button" class="btn btn-secondary" @click="dismissConfirmPrescription">Cancel</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
import prescriptionDetail from '@/components/prescription';
import identificationTypes from '@/config/identificationTypes';
import {
    convertDateToDDMMYYYY
} from '@/utilities';

export default {
    'components': {
        prescriptionDetail,
        popupModal
    },
    data () {
        return {
            'prescriptionList': [],
            'isEditPrescription': true,
            'pharmacyId': 'c790b8e8-a595-11ea-a7bf-00163e000d23',
            'prescriptionValidDays': null,
            'prescriptionValidUntil': null,
            'saveErrorMessage': null,
            'patientId': null,
            'savingPrescription': false,
            'userProfile': {
                'designation': null,
                'name': null,
                'email': null,
                'phoneNo': null,
                'identitifcationType': null,
                'identificationNumber': null,
                'joinedDate': null,
                'birthDate': null,
                'gender': null
            },
            'isGettingPrice': false,
            'total': 0
        };
    },
    mounted () {
        // Get patient details
        this.patientId = this.$route.params.patientId;
        this.getPatientDetails();
    },
    'methods': {
        getPatientDetails () {
            this.axios.get('user/GetUserDetails', {
                'params': {
                    'userId': this.patientId
                }
            }).then(({
                data
            }) => {
                if (data.data) {
                    let profileData = data.data;
                    this.userProfile.designation = profileData.d;
                    this.userProfile.name = profileData.f;
                    this.userProfile.email = profileData.e;

                    let idType = identificationTypes.find(i => i.value === profileData.ict);

                    this.userProfile.identitifcationType = idType ? idType.text : '-';
                    this.userProfile.identificationNumber = profileData.ic;
                    this.userProfile.phoneNo = profileData.p;
                    this.userProfile.joinedDate = convertDateToDDMMYYYY(data.data.jd);
                    this.userProfile.birthDate = profileData.bd === null ? 'Not Specified' : convertDateToDDMMYYYY(profileData.bd);
                    this.userProfile.gender = profileData.g === 0 ? 'Not Specified' : profileData.g === 1 ? 'Male' : 'Female';
                }
            });
        },
        validatePrescriptionValidDays () {
            return this.$validator.validateAll('prescription-valid-days');
        },
        async proceedToPayment () {
            const valid = await this.validatePrescriptionValidDays();
            if (this.prescriptionList.length <= 0) {
                this.saveErrorMessage = 'Your prescription list is empty!';
                return;
            } else if (!valid) {
                this.saveErrorMessage = 'Invalid Prescription Valid Days! Please check again.';
                return;
            }
            this.isGettingPrice = true;
            await this.getTotalPrice();
            return this.$refs.confirmPrescription.show();
        },
        async confirmProceed () {
            this.savingPrescription = true;

            // Data massage
            let prescriptionList = [];
            prescriptionList = this.prescriptionList.map((item) => ({
                'di': item.drugId,
                'q': item.quantity,
                'fd': item.consumptionFrequency,
                'qc': item.quantityPerConsumption,
                'si': null,
                'sr': null
            }));

            let prescriptionDetails = prescriptionList.length === 0 ? null : {
                'pl': prescriptionList,
                'pvd': this.prescriptionValidDays,
                'sr': this.prescriptionSpecialReminder
            };

            // Call API
            this.axios.post('Clinic/CreateNewPrescription', {
                'patientId': this.patientId,
                'prescriptionDetails': prescriptionDetails
            }).then(({ data }) => {
                this.$refs.confirmPrescription.hide();
                this.redirectToPaymentPage(data.data.clinicPaymentId);
            });
        },
        redirectToPaymentPage (clinicPaymentId) {
            this.$router.push({
                'name': 'clinic-payment-details',
                'params': {
                    'clinicPaymentId': clinicPaymentId
                }
            });
        },
        dismissConfirmPrescription () {
            this.$refs.confirmPrescription.hide();
        },
        viewPatientPastPrescriptions () {
            let route = this.$router.resolve({
                'name': 'clinic-past-prescriptions',
                'params': {
                    'patientId': this.patientId
                }
            });
            window.open(route.href, '_blank');
        },
        async getTotalPrice () {
            // Data massage
            let prescriptionList = [];
            prescriptionList = this.prescriptionList.map((item) => ({
                'di': item.drugId,
                'q': item.quantity,
                'fd': item.consumptionFrequency,
                'qc': item.quantityPerConsumption,
                'si': null,
                'sr': null
            }));

            let prescriptionDetails = prescriptionList.length === 0 ? null : {
                'pl': prescriptionList,
                'pvd': this.prescriptionValidDays,
                'sr': this.prescriptionSpecialReminder
            };

            await this.axios.post('Clinic/GetPrescriptionPrice', {
                'prescriptionDetails': prescriptionDetails
            }).then(({ data }) => {
                this.isGettingPrice = false;
                this.total = data.data.total;
            });
        }
    }
};
</script>

<style>
</style>
